import React from 'react';

export const TitleOverlay = ({ breathingPhase }) => {
  const getBreathingText = () => {
    switch (breathingPhase) {
      case 'inhale':
        return 'breathe in...';
      case 'hold':
        return 'hold...';
      case 'exhale':
        return 'breathe out...';
      default:
        return 'breathe deeply...';
    }
  };

  return (
    <div className="title-overlay fade-in">
      <h1>Tranquil Waters</h1>
      <p className={`breathing-text ${breathingPhase}`}>
        {getBreathingText()}
      </p>
    </div>
  );
};
